/**
 * Disclaimer superscripts
 *
 * Replaces the authoring token  !<<N>>!  or  !<<N,M,...>>!  found anywhere in
 * page text with a superscript that links to the matching disclaimer anchor:
 *
 *   !<<2,4>>!  ->  <sup><a class="disclaimer-superscript" href="#disc-2">2</a>,
 *                      <a class="disclaimer-superscript" href="#disc-4">4</a></sup>
 *
 * Optional inline CSS may be given after the >> and before the closing !. It is
 * applied to the <sup> element:
 *
 *   !<<2,4>>color: #fff; font-size: .5rem!
 *     -> <sup style="color: #fff; font-size: .5rem">
 *          <a class="disclaimer-superscript" href="#disc-2">2</a>,
 *          <a class="disclaimer-superscript" href="#disc-4">4</a></sup>
 *
 * The links inherit color/decoration from the <sup> via the
 * .disclaimer-superscript CSS rule, so styling the <sup> styles the numbers too.
 * With no style the superscript inherits the surrounding text color (so a white
 * heading yields white superscripts) instead of the default link blue.
 *
 * The #disc-N anchors are already placed on the disclaimers at the bottom of the
 * page. This replaces the old ASCII/unicode superscript characters (²˒⁴) that
 * render inconsistently across browsers/fonts.
 */
(function () {
  // Matches !<<2>>! , !<<2, 4>>! , !<<2,4>>color:#fff; font-size:.5rem!
  // Group 1: comma-separated numbers.
  // Group 2: optional inline CSS. `!` ends the token, except `!important`, which
  // is allowed inside the CSS.
  var PATTERN = /!<<\s*([0-9]+(?:\s*,\s*[0-9]+)*)\s*>>((?:[^!]|!(?=important\b))*)!/g;

  function buildSup(numbersStr, style) {
    // Guard the attribute: trim, and neutralize any double quotes that would
    // otherwise close the style attribute early.
    var css = (style || '').trim().replace(/"/g, "'");
    var styleAttr = css ? ' style="' + css + '"' : '';
    var links = numbersStr
      .split(',')
      .map(function (n) { return n.trim(); })
      .filter(Boolean)
      .map(function (n) {
        return '<a class="disclaimer-superscript" href="#disc-' + n + '">' + n + '</a>';
      })
      .join(',');
    return '<sup' + styleAttr + '>' + links + '</sup>';
  }

  function replaceDisclaimers(root) {
    root = root || document.body;
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('!<<') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        var tag = node.parentNode && node.parentNode.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    // Collect first, then mutate — mutating during the walk is unsafe.
    var targets = [];
    var node;
    while ((node = walker.nextNode())) {
      targets.push(node);
    }

    targets.forEach(function (textNode) {
      var html = textNode.nodeValue.replace(PATTERN, function (_match, nums, style) {
        return buildSup(nums, style);
      });
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var frag = document.createDocumentFragment();
      while (temp.firstChild) {
        frag.appendChild(temp.firstChild);
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  // Expose so dynamically injected content (sliders, quick views, etc.) can
  // re-run it on a specific subtree: window.replaceDisclaimers(el)
  window.replaceDisclaimers = replaceDisclaimers;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      replaceDisclaimers();
    });
  } else {
    replaceDisclaimers();
  }
})();
